export default __webpack_public_path__ + "assets/29e4def032cf45b23246ba93d87aeeba.jpg";